import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { RegionModel } from "src/app/hubadmin/shared/models/region";
import { StateModel } from "src/app/hubadmin/shared/models/state";
import {
  chillerBonusPointSchemeModel,
  ChillerRegionwiseScheme,
  ChillerScheme,
  ChillerSelectionModel,
  GeoGroupModel,
} from "src/app/hubadmin/shared/models/visibility";
import { AdminDataProvider } from "src/app/hubadmin/shared/providers/master-provider/admin-data.provider";
import { RegionProvider } from "src/app/hubadmin/shared/providers/region.provider";
import { StateProvider } from "src/app/hubadmin/shared/providers/state.provider";
import { DateFormateService } from "src/app/services/date-formate.service";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";

@Component({
  selector: "app-chiller-scheme",
  templateUrl: "./chiller-scheme.component.html",
  styleUrls: ["./chiller-scheme.component.scss"],
})
export class ChillerSchemeComponent implements OnInit {
  addOrEditState: string;
  formGroup: FormGroup;
  modalRef: BsModalRef;
  pageNumber: any = 1;
  getPaginationCount: any;
  submitted: boolean = false;
  chillerRegionScheme: ChillerRegionwiseScheme[];
  chillerScheme: ChillerScheme[];
  @Input() model: ChillerRegionwiseScheme = new ChillerRegionwiseScheme();
  chillerSelection: ChillerSelectionModel[];
  geoGroupNames: GeoGroupModel[];
  regions: RegionModel[];
  states: StateModel[];
  stateFilteredByRegion: StateModel[];
  minDate: { year: number; month: number; day: number; };
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
    private modalServiceNgx: BsModalService,
    public regionProvider: RegionProvider,
    private formateDate: DateFormateService,
    public stateProvider: StateProvider,
    public alertService: AlertService,
    private router: Router,
  ) {
    this.formGroup = this.fb.group({
      geo_group_id: ["", Validators.required],
      points: ["", Validators.required],
      chiller_pure_impure_selection_id: ["", Validators.required],
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
    });

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit() {
    this.getChillerRegionScheme();
  }

  /************************************/
  // convenience getter for easy access to form fields
  get f() {
    return this.formGroup.controls;
  }
  /*********************************** */

  getChillerRegionScheme() {
    this.apiService
      .getHeaders(
        this.apiConfig.getChillerSchemes + "?page=" + this.pageNumber
      )
      .subscribe(
        (res: any) => {
          this.chillerScheme = res.body.data as ChillerScheme[];
          this.getPaginationCount = res.headers.get("X-Pagination-Total-Count");
          if (this.chillerScheme.length > 0) {
            this.chillerScheme.forEach((item) => {
              item.show = false;
              item.statusString = item.status == 1 ? "Active" : "Inactive";
              if (new Date(item.start_date) >= new Date()) {
                item.show = true;
              }
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getGeoGroup() {
    this.apiService.getHeaders(this.apiConfig.getGeoGroups).subscribe(
      (res: any) => {
        this.geoGroupNames = res.body.data as GeoGroupModel[];
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getChillerSelection() {
    this.apiService.getHeaders(this.apiConfig.getChillerSelection).subscribe(
      (res: any) => {
        this.chillerSelection = res.body.data as ChillerSelectionModel[];
      },
      (err) => {
        console.log(err);
      }
    );
  }

  paginationClick(pageNumber) {
    this.pageNumber = pageNumber;
    this.getChillerRegionScheme();
  }

  addChillerSelection() {
    this.router.navigate(["/", "hubAdmin", "add-edit-chiller-scheme", '']);
  }

  editState(item) {
    this.model = item;
    this.router.navigate(["/", "hubAdmin", "add-edit-chiller-scheme", item.id]);
  }

  showStateModal(template) {
    this.modalService.open(template, {
      centered: true,
      backdrop: "static",
    });
  }

  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.submitted = false;
    this.modalService.dismissAll();
    this.formGroup.reset();
    this.model = new ChillerRegionwiseScheme();
  }

  onSubmit() {
    this.submitted = true;
    console.log(this.formGroup);
    if (this.formGroup.invalid) {
      return;
    }
    this.model.start_date = this.formateDate.formateDate(this.model.startDate);
    this.model.end_date = this.formateDate.formateDate(this.model.endDate);
    let apiUrl;
    if (this.addOrEditState == "add") {
      apiUrl = this.apiConfig.chillerRegionSchemeCreate;
      this.apiService.post(apiUrl, this.model).subscribe(
        (res: any) => {
          console.log("successfully Added", res);
          this.model.chiller_pure_impure_selection_name = this.chillerSelection.find(
            (i) => i.id == this.model.chiller_pure_impure_selection_id
          ).selection_value;
          this.chillerRegionScheme.push(this.model);
          this.alertService.success(res.data.message);
          this.clearSuccess();
          this.decline();
          this.getChillerRegionScheme();
        },
        (err) => {
          console.log("err", err);
        }
      );
    } else if (this.addOrEditState == "edit") {
      apiUrl =
        this.apiConfig.chillerRegionSchemeUpdate + "?id=" + this.model.id;
      this.apiService.put(apiUrl, this.model).subscribe(
        (res: any) => {
          console.log("successfully Updated", res);
          this.decline();
          this.alertService.success(res.data.message);
          this.clearSuccess();
        },
        (err) => {
          console.log("err", err);
        }
      );
    }
  }

  reset() {
    this.formGroup.reset();
  }

  OnChange(item) {
    this.stateFilteredByRegion = this.states.filter((i) => i.region_id == item);
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  changeStatus(item: ChillerRegionwiseScheme) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.chillerSchemeUpdate + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.alertService.success(res.data.message);
        this.clearSuccess();
      });
  }
}
